﻿export const siteStrings = {
    connectionFailed: 'Unable to connect, check your internet connection',
    contactSending: 'Sending...',
    contactSent: 'Thank you. Your message has been sent.',
    contactFailed: 'The message could not be sent. Please email jedwin@digitaljedwin.com directly.',
    subscriptionSubmitting: 'Subscribing...',
    subscriptionAccepted: 'If this address is not already subscribed, check your email for a confirmation link.',
    subscriptionFailed: 'The subscription request could not be completed. Please try again later.',
    subscriptionConfirmed: 'Your email address is confirmed. Thank you for subscribing.',
    subscriptionAlreadyConfirmed: 'This email address has already been confirmed.',
    subscriptionConfirmationExpired: 'This confirmation link has expired. Submit your email address again to receive a new link.',
    subscriptionConfirmationInvalid: 'This confirmation link is invalid.',
    unsubscribeChecking: 'Checking your unsubscribe link...',
    unsubscribePrompt: 'Select Unsubscribe to stop receiving photography updates.',
    unsubscribeInvalid: 'This unsubscribe link is invalid or has already been used.',
    unsubscribeSubmitting: 'Unsubscribing...',
    unsubscribeComplete: 'You have been unsubscribed.',
    unsubscribeFailed: 'The unsubscribe request could not be completed. Please try again later.',
    featuredPhotoCloseLabel: 'Close featured photograph',
    featuredPhotoPreviousLabel: 'Show previous photograph',
    featuredPhotoNextLabel: 'Show next photograph',
    featuredPhotoCopyLink: 'Copy link',
    featuredPhotoLinkCopied: 'Link copied.',
    featuredPhotoLinkCopyFailed: 'The link could not be copied.',
    orderPrint: 'Order print — {price}',
    orderPrintLabel: 'Order a 13×19 inch luster print of {title} for {price}',
    orderPrintOpening: 'Opening checkout...',
    orderPrintFailed: 'Checkout could not be opened. Please try again.',
    orderThanksChecking: 'Confirming your order...',
    orderThanksPaid: 'Your order {orderNumber} is confirmed.',
    orderThanksProcessing: 'Your payment was received. Your order is being confirmed, and a confirmation email is on its way.',
    orderThanksDetails: 'Your print will ship rolled in a tube within {days} business days. A confirmation email is on its way, and I will email you again when your print ships.',
    orderThanksUnpaid: 'This order has not been paid. If you were charged, please contact me and I will sort it out.',
    orderThanksInvalid: 'This order link is invalid. If you placed an order, check your email for the confirmation.',
    orderThanksFailed: 'Your order status could not be loaded. If you placed an order, check your email for the confirmation.',
    pauseHomepagePlayback: 'Pause automatic gallery playback',
    resumeHomepagePlayback: 'Resume automatic gallery playback',
    collectionLoadFailed: 'The collection could not be loaded. Please try again.'
} as const;